import { HeaderBreadcrumb } from 'common/ui/Header';
import React from 'react';
import { SourcingSharedJobInformationBackProps } from 'modules/sourcing-shared/shared-stores/types';
import { CampaignCreationSharedJobInformation } from 'modules/campaign-creation-shared/components';
import { type CampaignCreationSharedJobInformationFormData } from 'modules/campaign-creation-shared/forms';
import { useOrganization } from 'core/stores/hooks/useOrganization';
import { Flags, useFlag } from 'services/flags';

type SourcingSharedJobInformationStepProps = {
  headerBreadcrumbs: HeaderBreadcrumb[];
  defaultFormData: CampaignCreationSharedJobInformationFormData | null;
  onJobInformationBack: (props: SourcingSharedJobInformationBackProps) => void;
  onJobInformationNext: (
    formData: CampaignCreationSharedJobInformationFormData
  ) => void;
  title?: string;
};

const CURRENT_BREADCRUMB_TITLE = 'Check job details';

export const SourcingSharedJobInformationStep: React.FC<
  SourcingSharedJobInformationStepProps
> = ({
  headerBreadcrumbs,
  defaultFormData,
  onJobInformationBack,
  onJobInformationNext,
  title
}) => {
  const sourcingChannelSelectionEnabled = useFlag(
    Flags.SOURCING_CHANNEL_SELECTION
  );
  const organization = useOrganization();
  const defaultValues: CampaignCreationSharedJobInformationFormData = {
    jobTitle: defaultFormData?.jobTitle || '',
    employerName: defaultFormData?.employerName || '',
    location: defaultFormData?.location || '',
    contractType: defaultFormData?.contractType || '',
    additionalContext: defaultFormData?.additionalContext || ''
  };

  return (
    <CampaignCreationSharedJobInformation
      title={title}
      currentBreadcrumb={CURRENT_BREADCRUMB_TITLE}
      breadcrumbs={headerBreadcrumbs}
      onBack={() =>
        onJobInformationBack({
          isChannelSelectionFeatureFlagEnabled:
            sourcingChannelSelectionEnabled ?? false,
          organizationChannelsEnabled: organization.channelsEnabled ?? []
        })
      }
      defaultValues={defaultValues}
      onSubmit={onJobInformationNext}
    />
  );
};
